/**
 * Service that computes seat sale restrictions for a given seat and ticket type or item package.
 */
class SeatSaleRestrictionService {
  static #instance = null

  constructor () {
    if (!SeatSaleRestrictionService.#instance) {
      this.areaCategoryCache = {}
      SeatSaleRestrictionService.#instance = this
    }
    return SeatSaleRestrictionService.#instance
  }

  getAreaCategoryForSeat (seat, configuration) {
    if (configuration.version !== this.areaCategoryCache.version) {
      this.areaCategoryCache = {
        version: configuration.version,
        data: _.keyBy(configuration.seatChartAreaCategories.data, 'id')
      }
    }

    return this.areaCategoryCache.data[seat.areaCategoryId]
  }

  isSeatSaleAllowed (seat, ticketTypeOrPackage) {
    if (!ticketTypeOrPackage.isModel) return false

    const typeName = ticketTypeOrPackage.typeName

    if (typeName === 'TicketType') {
      return this.isSeatSaleAllowedForTicketType(seat, ticketTypeOrPackage)
    } else if (typeName === 'ItemPackage') {
      return this.isSeatSaleAllowedForPackage(seat, ticketTypeOrPackage)
    } else {
      return false
    }
  }

  isSeatSaleAllowedForTicketType (seat, ticketType) {
    if (!ticketType.appliesToSpecificSeats && _.isNil(seat.areaCategoryId)) {
      return true
    }

    if (_.isNil(seat.areaCategoryId)) {
      return false
    }

    if (_.isNil(ticketType.configuration.seatChartAreaCategories)) {
      ticketType.$rollbar?.error('TicketType.ticketTypeAllowsSeat: ClientConfig error: seatChartAreaCategories not found', { seat, ticketType: ticketType.id })
      return false
    }

    const category = this.getAreaCategoryForSeat(seat, ticketType.configuration)

    if (_.isNil(category)) {
      ticketType.$rollbar?.error('TicketType.ticketTypeAllowsSeat: seatChartAreaCategory override provided, but configuration is missing the model', { seat, ticketType: ticketType.id })
      return false
    }

    return category.seatAllowedForTicketType(ticketType.id)
  }

  isSeatSaleAllowedForPackage (seat, itemPackage) {
    return _(itemPackage.itemPackageItems.data).map('ticketType').compact().some(ticketType => this.isSeatSaleAllowedForTicketType(seat, ticketType))
  }
}

const seatSaleRestrictionService = new SeatSaleRestrictionService()
export default seatSaleRestrictionService
